export function resolveRef(apiSpec, ref) {
  const parts = ref.split("/").slice(1);
  return parts.reduce((current, part) => current?.[part], apiSpec);
}

export function copyToClipboard(text) {
  if (navigator?.clipboard?.writeText) {
    return navigator.clipboard.writeText(text);
  }
  const textarea = document.createElement("textarea");
  textarea.value = text;
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand("copy");
  document.body.removeChild(textarea);
  return Promise.resolve();
}
